import {
  Box,
  Collapse,
  Divider,
  IconButton,
  Paper,
  TableCell,
  TableRow,
  useTheme
} from '@mui/material';
import { Fragment, useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import BSTableBodyCell from './BSTableBodyCell';

const BSTableRowCollapsible = ({ children, subContent, ...props }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  return (
    <Fragment>
      <TableRow
        sx={{
          '& > *': { borderBottom: 'unset' },
          backgroundColor: (theme) => theme.palette.background.paper
        }}>
        <BSTableBodyCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
            color="primary">
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </BSTableBodyCell>
        {children}
      </TableRow>
      <TableRow
        sx={{
          '& > *': { borderBottom: 'unset' },
          backgroundColor: (theme) => theme.palette.background.paper
        }}>
        <BSTableBodyCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box
              sx={{ m: 1, p: 3, borderRadius: 3, backgroundColor: theme.palette.background.main }}>
              {subContent}
            </Box>
            {/* <Divider
              sx={{
                borderColor: theme.palette.primary.main,
                width: '20%',
                justifySelf: 'center',
                my: 2
              }}
            /> */}
          </Collapse>
        </BSTableBodyCell>
      </TableRow>
    </Fragment>
  );
};

export default BSTableRowCollapsible;
